import { Box } from '@backstage/ui';
import {
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  isOrphan,
  hasCatalogProcessingErrors,
  hasRelationWarnings,
  EntityRelationWarning,
} from '@backstage/plugin-catalog';
import styles from './entity-warning.module.css';

export const EntityWarningContent = () => (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Box className={styles.fullWidth}>
          <EntityOrphanWarning />
        </Box>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Box className={styles.fullWidth}>
          <EntityRelationWarning />
        </Box>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Box className={styles.fullWidth}>
          <EntityProcessingErrorsPanel />
        </Box>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);
